var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFortra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.37 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8fe5f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FORTRA_RGB_Forest"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.44,26.44l14.81,29.94h-29.62l14.81-29.94Zm-32.38,40.85h64.76L363.44,1.83l-32.38,65.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 2.85 0 67.28 11.95 67.28 11.95 41.81 47.92 41.81 47.92 30.31 11.95 30.31 11.95 14.36 47.92 14.36 47.92 2.85 0 2.85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.12,33.54h-23.5V14.17h23.5c5.08,0,9.05,4.25,9.05,9.68s-4.06,9.68-9.05,9.68m21-9.68c0-11.58-9.42-21-21-21h-35.45v64.43h11.95v-22.88h20.43l13.28,22.88h13.19l-14.51-24.83c7.28-3.33,12.12-10.69,12.12-18.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m301.95,33.54h-23.5V14.18h23.5c5.08,0,9.05,4.25,9.05,9.68s-4.06,9.68-9.05,9.68m21-9.68c0-11.58-9.42-21-21-21h-35.45v64.43h11.95v-22.88h20.43l13.28,22.88h13.19l-14.51-24.83c7.28-3.33,12.12-10.68,12.12-18.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.92 2.86 196.92 14.36 221.07 14.36 221.07 67.28 233.02 67.28 233.02 14.36 257.08 14.36 257.08 2.86 196.92 2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.83,56.68c-12.21,0-21.41-9.32-21.41-21.68s9.21-21.68,21.41-21.68,21.41,9.32,21.41,21.68-9.21,21.68-21.41,21.68m0-55.04c-18.7,0-33.35,14.65-33.35,33.35s14.65,33.35,33.35,33.35,33.35-14.65,33.35-33.35S109.53,1.65,90.83,1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m408.27,59.36h-1.67v7.89h1v-6.91l2.99,6.96h.74l3.01-7v6.96h1.02v-7.89h-1.61l-2.74,6.4-2.75-6.4Zm-10.97,1h3.28v6.89h1.08v-6.89h3.28v-1h-7.63v1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortra);
export default __webpack_public_path__ + "static/media/fortra.e99c465208ec4a5a761aefb134968eac.svg";
export { ForwardRef as ReactComponent };